import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import base from './components/base.js'
import md5 from 'js-md5'
import 'swiper/dist/css/swiper.css'
import "bootstrap"
import "bootstrap/dist/css/bootstrap.css"


Vue.prototype.axios = axios
Vue.prototype.md5 = md5
Vue.prototype.base = base


axios.defaults.timeout = 6000 // 请求超时

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, DELETE'
// axios.defaults.headers['Access-Control-Allow-Headers'] = 'Content-Type, X-Auth-Token, Origin'

axios.defaults.baseURL = (process.env.NODE_ENV == 'development' ? '/api':'https://admin.xiaojudai.cn/index'  )  // api 即上面 vue.config.js 中配置的地址
Vue.config.productionTip = false
axios.interceptors.request.use( config=> {      //请求拦截器
// config.headers.Cookie
	let _data =Object.assign({},config.data)
	if(_data.sign){
		delete _data.sign
	}
	if(_data.timestamp){
		delete _data.timestamp
	}
	let _timestamp = parseInt(new Date().getTime()/1000)
	_data.timestamp = _timestamp
	_data.key = "74260f176fef3fe877351cf446c981c8"
	_data = base.objSort(_data)
	let _string = ""
	
    for(let name in _data) {
		
		if(typeof _data[name]=="object"){
			_data[name] = JSON.stringify(_data[name])
		}
		
		_string += name + "="+ _data[name] + "&"
	
	}

	_string=_string.substring(0,_string.length-1)
	

	config.data.timestamp = _timestamp
	config.data.sign = md5(_string).toUpperCase()

　　return config
}, error=>{
return Promise.reject(error)
});



axios.interceptors.response.use(

 response => {

   //返回拦截器   
       
//      console.log(response) 
     return response 
},

 error => {

        
return Promise.reject(error)     
});












axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
router.beforeEach((to, from, next) =>{
  
	if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
		store.commit("checkMemberId")
		if (store.state.token) { // 判断本地是否存在token
			next()
		} else {
      		// 未登录,跳转到登陆页面
			next({path: '/Login'})
		}
	} else {
			next()
	}
   })
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = "橘袋"
  }
})
Vue.use(VueAxios,axios)
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
